import { Permissions } from "./Permissions";

export const FeaturePermissions = {
  "dashboard": [
    Permissions.UiAdmin,
  ],
  "appearance_applicant_channel": [
    Permissions.UiAdmin,
  ],
  "appearance_dashboard": [
    Permissions.UiAdmin
  ],
  "appearance_device": [
    Permissions.UiAdmin
  ],
  "appearance_employee_channel": [
    Permissions.UiAdmin
  ],
  "appearance_launchpad": [
    Permissions.UiAdmin,
  ],
  "boltsmanage": [
    Permissions.BranchAdmin,
  ],
  "ach_dashboard": [
    Permissions.UiAdmin
  ],
  "appearance": [
    Permissions.UiAdmin
  ],
  "connection_properties": [
    Permissions.LaunchpadAdmin,
  ],
  "cron": [
    Permissions.LaunchpadAdmin,
  ],
  "funding": [
    Permissions.BranchAdmin,
  ],
  "lookups": [
    Permissions.BranchAdmin,
  ],
  "mapping": [
    Permissions.BranchAdmin
  ],
  "ocr": [
    Permissions.BranchAdmin
  ],
  "pigeopn": [
    Permissions.PigeonAdmin
  ],
  "properties": [
    Permissions.LaunchpadAdmin
  ],
  "questionnaire": [
    Permissions.BranchAdmin
  ],
  "regions": [
    Permissions.BranchAdmin
  ],
  "rules": [
    Permissions.BranchAdmin,
    Permissions.BranchRuleAdmin
  ],
  "unc_config": [
    Permissions.LaunchpadAdmin
  ],
  "user_mgr": [
    Permissions.LaunchpadAdmin
  ],
  "verbiage": [
    Permissions.UiAdmin
  ],
  "workflow": [
    Permissions.UiAdmin
  ],
  "zip_code_white": [
    Permissions.BranchAdmin
  ],
  "user_access": [
    Permissions.LaunchpadAdmin
  ],
  "disclosure": [
    Permissions.BranchAdmin
  ],
  "geofence": [
    Permissions.LaunchpadAdmin
  ],
  "schedules": [
    Permissions.LaunchpadAdmin
  ],
  "users": [
    Permissions.LaunchpadAdmin
  ],
  "device_device": [
    Permissions.LaunchpadAdmin
  ],
  "new_business_workspace": [
    Permissions.BranchUser,
  ],
  "boltsbranch": [
    Permissions.BranchUser
  ],
  "search_workspaces": [
    Permissions.BranchUser
  ],
  "boltsdevice": [
    Permissions.LaunchpadAdmin
  ],
  "dashboard_view": [
    Permissions.UiAdmin
  ],
  "new_person_workspace": [
    Permissions.BranchUser
  ],
  "appearance_manage": [
    Permissions.UiAdmin
  ],
  "oAuth": [
    Permissions.BranchAdmin
  ],
  "product": [
    Permissions.BranchAdmin
  ],
  "export_all_rules": [
    Permissions.BranchRuleAdmin
  ],
  "images": [
    Permissions.UiAdmin
  ],
  "branch_authorizedByAll_button": [
    Permissions.BranchUser
  ],
  "documentexport": [
    Permissions.BranchDocumentExport
  ],
  "csidocument": [
    Permissions.BranchUser,
  ],
  "holiday": [
    Permissions.BranchAdmin
  ],
  "dashboard_settings": [
    Permissions.UiAdmin
  ],
  "account_intentions": [
    Permissions.BranchAdmin
  ],
  "fields": [
    Permissions.BranchAdmin
  ],
  "plaid": [
    Permissions.BranchAdmin
  ],
  "wolterskluwer": [
    Permissions.BranchAdmin
  ],
  "self_indexed_disclosure_export": [
    Permissions.BranchDocumentExport
  ],
  "account_indexed_disclosure_export": [
    Permissions.BranchDocumentExport
  ],
  "estatement_export": [
    Permissions.BranchDocumentExport
  ],
  "identification_image_export": [
    Permissions.BranchDocumentExport
  ],
  "services": [
    Permissions.BranchAdmin
  ],
  "tracker": [
    Permissions.UiAdmin
  ],
  "synergy": [
    Permissions.SynergyAdmin,
  ],
  "relationships": [
    Permissions.BranchAdmin
  ],
  "wolters_kluwer_transactions": [
    Permissions.BranchAdmin
  ],
  "synergy_mapping": [
    Permissions.SynergyAdmin,
  ],
  "user_log": [
    Permissions.LaunchpadAdmin
  ],
  "business_type": [
    Permissions.BranchAdmin
  ],
  "business_documents": [
    Permissions.BranchAdmin
  ],
  "promo_codes": [
    Permissions.BranchAdmin
  ],
  "new_ui_workspace": [
    Permissions.BranchUser
  ],
  "new_ui_new_person_workspace": [
    Permissions.BranchUser
  ],
  "new_ui_new_business_workspace": [
    Permissions.BranchUser
  ],
  "new_ui_existing_workspaces": [
    Permissions.BranchUser
  ],
  "new_ui_show_joint_and_checkbox": [
    Permissions.BranchUser
  ],
  "new_ui_dashboard": [
    Permissions.UiAdmin
  ],
  "new_ui_dashboard_settings": [
    Permissions.UiAdmin
  ],
  "new_ui_management_console": [
    Permissions.BranchAdmin,
    Permissions.UiAdmin,
    Permissions.LaunchpadAdmin,
    Permissions.AlloyAdmin,
    Permissions.SynergyAdmin,
    Permissions.PigeonAdmin,
    Permissions.BranchRuleAdmin
  ],
  "new_ui_business": [
    Permissions.BranchAdmin
  ],
  "new_ui_cip": [
    Permissions.BranchAdmin
  ],
  "new_ui_disclosures": [
    Permissions.BranchAdmin
  ],
  "new_ui_enrollment_intentions": [
    Permissions.BranchAdmin
  ],
  "new_ui_export_files": [
    Permissions.BranchDocumentExport,
  ],
  "new_ui_self_indexed_disclosure_export": [
    Permissions.BranchDocumentExport,
  ],
  "new_ui_account_indexed_disclosure_export": [
    Permissions.BranchDocumentExport,
  ],
  "new_ui_estatement_export": [
    Permissions.BranchDocumentExport,
  ],
  "new_ui_identification_image_export": [
    Permissions.BranchDocumentExport
  ],
  "new_ui_wolters_kluwer_transactions": [
    Permissions.BranchDocumentExport,
  ],
  "new_ui_fields": [
    Permissions.UiAdmin
  ],
  "new_ui_funding": [
    Permissions.BranchAdmin
  ],
  "new_ui_mapping": [
    Permissions.BranchAdmin
  ],
  "new_ui_oauth_providers": [
    Permissions.BranchAdmin
  ],
  "new_ui_ocr": [
    Permissions.BranchAdmin
  ],
  "new_ui_pigeon": [
    Permissions.PigeonAdmin
  ],
  "new_ui_products": [
    Permissions.BranchAdmin
  ],
  "new_ui_promo_codes": [
    Permissions.BranchAdmin
  ],
  "new_ui_properties": [
    Permissions.LaunchpadAdmin
  ],
  "new_ui_questionnaire": [
    Permissions.BranchAdmin
  ],
  "new_ui_relationships": [
    Permissions.BranchAdmin
  ],
  "new_ui_rules": [
    Permissions.BranchAdmin,
    Permissions.BranchRuleAdmin
  ],
  "new_ui_scheduled_tasks": [
    Permissions.LaunchpadAdmin
  ],
  "new_ui_services": [
    Permissions.BranchAdmin
  ],
  "new_ui_synergy": [
    Permissions.SynergyAdmin,
  ],
  "new_ui_users_groups": [
    Permissions.LaunchpadAdmin
  ],
  "new_ui_verbiage": [
    Permissions.UiAdmin
  ],
  "new_ui_wolters_kluwer": [
    Permissions.BranchAdmin
  ],
  "new_ui_workflows": [
    Permissions.UiAdmin
  ],
  "new_ui_zip_codes": [
    Permissions.BranchAdmin
  ],
  "new_ui_cu_membership_eligibility": [
    Permissions.BranchAdmin
  ],
  "new_ui_journeys": [
    Permissions.AlloyAdmin
  ],
  "new_ui_applicant_review": [
    Permissions.BranchAdmin
  ],
  "new_ui_bsa_due_diligence": [
    Permissions.BranchAdmin
  ]
} as const
